:host {
  width: fit-content;
  height: auto;
  min-width: 0;
}

.header-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
  line-height: calc(var(--spacer) * 2);
  cursor: default;
  color: var(--main-titles-inputs-600);

  .header-top-row {
    display: flex;
    align-self: center;
    align-items: center;
    line-height: calc(var(--spacer) * 4);
    gap: calc(var(--spacer) * 0.5);
    font-weight: 400;
  }

  gz-tooltip {
    width: 100%;
    text-align: center;
    padding: 0 calc(var(--spacer) * 0.5);
  }
}

:host([clickable]) {
  .header-item {
    &:hover {
      cursor: pointer;
      color: var(--blue-layout-400-primary);
    }
  }
}

.fw-500 {
  font-weight: 500;
}

.line-height-32 {
  line-height: calc(var(--spacer) * 4);
}

.center {
  align-items: center;
  justify-content: center;
}

.gray-color::part(svgIcon) {
  fill: var(--grey-layout-200-disabled);
}
